var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 115,
    viewBox: "0 0 167 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2237 0.995236L4.70491 26.1992C3.33541 26.684 2.14989 27.5817 1.31191 28.7685C0.473926 29.9552 0.0247283 31.3727 0.0260269 32.8254L-3.04453e-06 107.481C-0.000929601 108.603 0.266992 109.709 0.781256 110.706C1.29552 111.703 2.0413 112.562 2.95595 113.212C3.8706 113.862 4.92755 114.283 6.03839 114.44C7.14923 114.597 8.28162 114.486 9.34066 114.116L76.2581 90.7299C80.015 89.4201 84.0995 89.4201 87.865 90.7385L154.421 114.09C155.479 114.462 156.612 114.574 157.723 114.418C158.834 114.262 159.892 113.842 160.808 113.193C161.724 112.544 162.47 111.685 162.986 110.689C163.501 109.692 163.77 108.586 163.77 107.464L163.727 32.6962C163.727 29.7148 161.848 27.0608 159.039 26.0699L87.8908 0.995236C84.1166 -0.331741 79.9978 -0.33174 76.2237 0.995236Z",
    fill: "#A1C74A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.683 99.5189L166.234 100.467L164.683 99.5189Z",
    fill: "#B22E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulation);
export default __webpack_public_path__ + "static/media/simulation.5ebcc0ef596f2e122b84becaa3a93f07.svg";
export { ForwardRef as ReactComponent };